// src/pages/common/COM001F1.jsx
import React, {useContext} from 'react';
import {AuthContext} from "contexts/AuthContext";
import {postData} from "utils/TransactionUtil";

import style from './COM001F1.module.scss';
import Icon from "components/Icon/Icon";
import Button from "components/Button/Button";

const COM001F1 = () => {

  const authContext = useContext(AuthContext);
  const userInfo = authContext.userInfo; // 사용자 정보 가져오기

  //로그 아웃 버튼 클릭 (추후 공통화 필요)
  const handleClick_logout__button = (e) => {
    e.preventDefault();

    let param ={
      lginId : userInfo.lginId
    };

    postData("/actionLogout",param).then((data) => {

      console.log(data? "정상 로그아웃":"오류 발생");

      authContext.onLogout(); //권한 컨테스트 로그아웃 처리
    });
  }

  return(
    <div className={style.Header_Cnt}>
      <div className={style.portalLogo}>
        EluNIR
      </div>
      <div className={style.infoBox}>
        <Button variant="Primary" size="md" addStyle={{width: "108px", height: "40px"}}
          onClick={handleClick_logout__button}>
          로그아웃<Icon id="exit_01" width="12" height="12"/>
        </Button>
      </div>
    </div>
  )
}
export default COM001F1;